import moment from "moment";
import momentDurationFormatSetup from "moment-duration-format";
import { ClockCircleOutlined } from "@ant-design/icons";
import { Image, TimePicker } from "antd";
import { orderBy, sumBy } from "lodash";
import dateArray from "moment-array-dates";
import NoAvar from "../asset/img/avatar-placeholder.jpg";

momentDurationFormatSetup(moment); // setup cho moment duration format
// cải thiện dữ liệu query được biến thành dạng dữ liệu xử lý được

export const timeTrackingToReport = ({ users, timeTracking, from, to }) => {
  //B1: Nhóm theo từng user rồi phân tích dữ liệu theo name, date, day theo cụm array
  console.log({ timeTracking });
  const noEmpty = filterByUser({ users, timeTracking });
  // console.log({ Givenusers: users });
  //B2:  Nhóm từng cụm này theo ngày

  const fromString = from?.format("DD/MM/YYYY");
  const toString = to?.format("DD/MM/YYYY");
  const dates =
    fromString === toString
      ? [fromString]
      : dateArray.range(from, to, "DD/MM/YYYY", true);

  let range = 0;

  const byDate = noEmpty?.map((item) => {
    const result = [];
    dates.forEach((d) => {
      let data = item?.filter((i) => i.date === d); // data theo ngày

      const length = data?.length;
      if (length > 0) {
        if (length > range) {
          // tìm max
          range = length;
        }
        // Lấy thông tin từng row
        const row = dataToRow(data);
        result.push(row);
      }
    });

    const sumBreaking = sumBy(result, "breakSeconds");
    const sumWorking = sumBy(result, "workSeconds");
    const fullName = result[0]?.fullName || "";
    const username = result[0]?.username || "";
    return {
      result,
      sumBreaking,
      sumWorking,
      fullName,
      username,
    };
  });
  const totalBreaking = sumBy(byDate, "sumBreaking");
  const totalWorking = sumBy(byDate, "sumWorking");
  const report = {
    range,
    data: byDate,
    totalBreaking,
    totalWorking,
  };

  return report;
};

const filterByUser = ({ users, timeTracking }) => {
  // console.log({ usersGive: users });
  const filter = users?.map((item) => {
    const fullName = `${item?.firstName} ${item?.lastName}`;
    const username = item?.username;
    const data = timeTracking?.filter((t) => t.user === item.id);
    const result = data?.map((d) => {
      const checkedAt = d?.checkedAt?.seconds
        ? moment(d?.checkedAt.toDate())
        : null;
      const date = checkedAt?.format("DD/MM/YYYY");
      const day = checkedAt?.format("ddd");
      return {
        ...d,
        day,
        date,
        fullName,
        username,
      };
    });

    // console.log({ result });

    return result;
  });

  return filter?.filter((item) => item?.length !== 0);
};

const dataToRow = (data) => {
  // Lấy thông tin từng row
  // console.log({ data });
  const fullName = data[0]?.fullName;
  const username = data[0]?.username;
  const date = data[0]?.date;
  const day = data[0]?.day;
  const user = data[0]?.user;
  const ordered = orderBy(data, "checkedAt", "asc");
  let workSeconds = 0;
  const length = ordered.length;
  const max = length % 2 === 0 ? length : length - 1;
  const check = ordered?.map((item, index) => {
    const checkedAt = item?.checkedAt;
    const seconds = checkedAt?.seconds;
    workSeconds =
      index < max
        ? index % 2 === 0
          ? workSeconds - seconds
          : workSeconds + seconds
        : workSeconds;
    const type = index % 2 === 0 ? "in" : "out";
    const timestamp = seconds && checkedAt.toDate();
    const time = moment(timestamp).format("hh:mm A");
    const id = item?.id;
    const screenshot = item?.screenshot;
    const subUrl = item?.subUrl;
    return {
      seconds,
      timestamp,
      time,
      id,
      item,
      type,
      screenshot,
      subUrl,
    };
  });
  let total = max > 1 ? check[max - 1].seconds - check[0]?.seconds : 0;
  const breakSeconds = total - workSeconds;
  const row = {
    fullName,
    username,
    date,
    day,
    check,
    total,
    user,
    workSeconds,
    breakSeconds,
  };
  return row;
};

export const getHeaderByRange = (range, dataReport) => {
  const { colSpanIndex: colSpan } = getDataRows(dataReport);
  // console.log({ colSpan });
  let midHeader = [];
  const mergedCell = (_, index) => {
    if (colSpan.includes(index)) {
      return {
        colSpan: 4 + range,
      };
    }
    return {};
  };

  const hideCell = (_, index) => {
    if (colSpan.includes(index)) {
      return {
        colSpan: 0,
      };
    }
    return {};
  };

  if (range) {
    for (let i = 0; i < range; i++) {
      const number = Math.round(i / 2) + (i % 2 === 0 ? 1 : 0);
      const id = i % 2 === 0 ? `in${number}` : `out${number}`;
      const label = i % 2 === 0 ? `In ${number}` : `Out ${number}`;
      const data = {
        dataIndex: id,
        title: label,
        key: id,
        align: "center",
        onCell: hideCell,
        render: (value) => (
          <div style={{ color: id?.includes("in") ? "green" : "red" }}>
            {value}
          </div>
        ),
      };
      midHeader = [...midHeader, data];
    }
  }

  const preHeader = [
    {
      dataIndex: "username",
      title: "Username",
      key: "Username",
      align: "left",
      onCell: mergedCell,
      render: (value) => (value === "Total:" ? <b>{value}</b> : value),
    },
    {
      dataIndex: "fullName",
      title: "Full Name",
      key: "Fullname",
      align: "left",
      sorter: (a, b) => a?.fullName?.length - b?.fullName?.length,
      onCell: hideCell,
    },
    {
      dataIndex: "date",
      title: "Date",
      key: "Date",
      align: "center",
      onCell: hideCell,
    },
    {
      dataIndex: "day",
      title: "Day",
      key: "Day",
      align: "center",
      onCell: hideCell,
    },
  ];
  const endHeader = [
    {
      dataIndex: "workingtime",
      title: "Working Time",
      key: "Working Time",
      align: "center",
    },
    {
      dataIndex: "breakingtime",
      title: "Breaking Time",
      key: "Breaking Time",
      align: "center",
    },
  ];

  const header = [...preHeader, ...midHeader, ...endHeader];
  return header;
};

// Chuyến giây sang giờ phút
export const secondsToHoursAndMinuteFormat = (seconds) => {
  if (seconds && seconds >= 0) {
    const time = moment
      .duration(seconds, "seconds")
      .format("HH:mm", { trim: false });
    return time;
  }
  return "00:00";
};

//get Data Rows for table

export const getDataRows = (reportData, photos, locations) => {
  console.log({ reportData });
  let final = [];
  reportData?.forEach((row) => {
    const sumBreaking = row?.sumBreaking;
    const sumWorking = row?.sumWorking;
    const result = row?.result;

    result?.forEach((d) => {
      let tableRow = {};
      const username = d?.username;
      const fullName = d?.fullName;
      const date = d?.date;
      const day = d?.day;
      const check = d?.check;
      const workingtime = d?.workSeconds;
      const breakingtime = d?.breakSeconds;
      tableRow = { ...tableRow, username, fullName, date, day };
      // console.log({d});
      check?.forEach((c, i) => {
        const number = Math.round(i / 2) + (i % 2 === 0 ? 1 : 0);
        const id = i % 2 === 0 ? `in${number}` : `out${number}`;
        const time = c?.time;
        const screenshot = c?.screenshot || NoAvar;
        // console.log(screenshot);
        // console.log({ c });
        // const lat = c?.item?.latitude || "";
        // const lon = c?.item?.longitude || "";
        const longAddress = c?.item?.subUrl || "";
        const address = shortAddress(longAddress);
        // console.log({ address });
        // const coordinate =
        //   lat !== "" && lon !== ""
        //     ? `${c?.item?.latitude}, ${c?.item?.longitude}`
        //     : "no location data";

        const coordinate = address !== "" ? address : "No location";

        const string = (
          <div>
            <div>{time}</div>
            {photos && (
              <div>
                {/* <img
                  style={{ width: 90, height: 90 }}
                  src={screenshot}
                  alt="image"
                /> */}
                <Image width={90} height={90} src={screenshot} />
              </div>
            )}
            {locations && <div style={{ color: "black" }}>{coordinate}</div>}
          </div>
        );

        tableRow = { ...tableRow, [id]: string };
      });
      tableRow = {
        ...tableRow,
        workingtime: secondsToHoursAndMinuteFormat(workingtime),
        breakingtime: secondsToHoursAndMinuteFormat(breakingtime),
      };
      final = [...final, tableRow];
    });

    const componentWorking = (
      <b style={{ color: "#1a76d2" }}>
        {secondsToHoursAndMinuteFormat(sumWorking)}
      </b>
    );
    const componentBreaking = (
      <b style={{ color: "red" }}>
        {secondsToHoursAndMinuteFormat(sumBreaking)}
      </b>
    );

    let sumRow = {
      username: "Total:",
      workingtime: componentWorking,
      breakingtime: componentBreaking,
    };

    final = [...final, sumRow];
  });

  const colSpan = final
    ?.map((d, index) => {
      const username = d?.username;
      const order = index;
      return {
        username,
        order,
      };
    })
    .filter((i) => i?.username === "Total:");

  const colSpanIndex = colSpan?.length > 0 ? colSpan?.map((t) => t?.order) : [];
  // console.log({ colSpan });

  return { final, colSpanIndex };
};

// --------------- GET DATA FOR EDITOR ------------- //
export const getHeaderByRangeEdit = (range) => {
  // console.log({ colSpan });
  let midHeader = [];

  if (range) {
    for (let i = 0; i < range; i++) {
      const number = Math.round(i / 2) + (i % 2 === 0 ? 1 : 0);
      const id = i % 2 === 0 ? `in${number}` : `out${number}`;
      const label = i % 2 === 0 ? `In ${number}` : `Out ${number}`;
      const data = {
        dataIndex: id,
        title: label,
        key: id,
        align: "center",

        render: (value) => (
          <div style={{ color: id?.includes("in") ? "green" : "red" }}>
            {value}
          </div>
        ),
      };
      midHeader = [...midHeader, data];
    }
  }

  const preHeader = [
    {
      dataIndex: "username",
      title: "Username",
      key: "Username",
      align: "left",
    },
    {
      dataIndex: "fullName",
      title: "Full Name",
      key: "Fullname",
      align: "left",
    },
    {
      dataIndex: "date",
      title: "Date",
      key: "Date",
      align: "center",
    },
    {
      dataIndex: "day",
      title: "Day",
      key: "Day",
      align: "center",
    },
  ];
  const endHeader = [
    {
      dataIndex: "workingtime",
      title: "Working Time",
      key: "Working Time",
      align: "center",
    },
    {
      dataIndex: "breakingtime",
      title: "Breaking Time",
      key: "Breaking Time",
      align: "center",
    },
  ];

  const header = [...preHeader, ...midHeader, ...endHeader];
  return header;
};

export const getDataRowsEdit = (reportData, range, selectedUpdateTime) => {
  // console.log({ reportData });
  let final = [];

  reportData?.forEach((row) => {
    const result = row?.result;

    //data
    result?.forEach((d) => {
      let tableRow = {};
      const username = d?.username;
      const fullName = d?.fullName;
      const date = d?.date;
      const day = d?.day;
      const check = d?.check;
      const user = d?.user;
      // const workingtime = d?.workSeconds;
      // const breakingtime = d?.breakSeconds;
      tableRow = { ...tableRow, username, fullName, date, day };

      const gap = range - check?.length;
      const arr = new Array(gap).fill(null);
      const checked = [...check, ...arr];
      // console.log({ checked });
      checked?.forEach((c, i) => {
        const number = Math.round(i / 2) + (i % 2 === 0 ? 1 : 0);
        const id = i % 2 === 0 ? `in${number}` : `out${number}`;

        const timestamp = c?.timestamp && moment(c?.timestamp);
        const unique = `${c?.id}-${id}`;
        const itemId = c?.item?.id;

        let select = {
          unique,
          time: timestamp,
          user,
          date,
          id: itemId ? itemId : "",
          action: c ? "update" : "create",
        };

        const string = c ? (
          <div>
            <TimePicker
              defaultValue={timestamp}
              placeholder=""
              style={{ width: "100%" }}
              format="hh:mm A"
              onChange={(value) => selectedUpdateTime(value, select)}
            />
          </div>
        ) : (
          <div>
            <TimePicker
              placeholder=""
              style={{ width: "100%" }}
              format="hh:mm A"
              onChange={(value) => selectedUpdateTime(value, select)}
            />
          </div>
        );

        tableRow = { ...tableRow, [id]: string };
      });
      tableRow = {
        ...tableRow,
        // workingtime: secondsToHoursAndMinuteFormat(workingtime),
        // breakingtime: secondsToHoursAndMinuteFormat(breakingtime),
      };
      final = [...final, tableRow];
    });
  });

  return final;
};

const shortAddress = (text) => {
  const address = text;
  const secondCommaIndex = address.indexOf(",", address.indexOf(",") + 1);
  const result = address.substring(0, secondCommaIndex);
  return result;
};
